import React from 'react';
import { connect, DispatchProp } from 'react-redux';

import { sidebarActions, toastMessageActions } from '../../../actions';

interface Props extends DispatchProp {
    errorMessage?: string;
}
export class PaneInitFailureContent extends React.PureComponent<Props, {}> {
    constructor(props) {
        super(props);
        props.dispatch(sidebarActions.visibleSet(false));
        props.dispatch(
            toastMessageActions.toastError(
                'Content Error',
                props.errorMessage ?? "We couldn't find that content! Please try again.",
            ),
        );
    }

    render() {
        return null;
    }
}

export default connect()(PaneInitFailureContent);
